import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import '../card.css';
import axios from 'axios';
import "react-notifications-component/dist/theme.css";
import i18n from '../i18n';
import {connect} from 'react-redux';
import {reactLocalStorage} from 'reactjs-localstorage';
import Menutest from './menu.js';
import {  TextArea } from 'semantic-ui-react'
import { API_BASE_URL } from "../utils/endpoints";

  class EditTemplate extends React.Component {

    constructor(props) {
       super(props);
       this.state = {
         template_name: '',
         template_value:''
      
       }
     }



    componentDidMount(){
   

           var lang=i18n.language;
           if(lang ==="ar")
           {
             document.querySelector('.title_req').style = 'float:right;';       
         
             document.querySelector('.title_req1').style = 'float:right;';
           }




    }

    componentWillMount() {
      
        var id=reactLocalStorage.get('id_user_edit_template');
        var token=reactLocalStorage.get('accessToken');


        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        var page_num=0;
        var search=''
        if(ip.includes(s2))
        {
         apiBaseUrl =API_BASE_URL + "/core/corpsms/gettemplate?page="+page_num+"&filter="+search;   
        }
        
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/corpsms/gettemplate?page="+page_num+"&filter="+search;
        }
   
    var i;
   
        var headers = {'Content-Type': 'application/json', 'token' :token }
        axios.get(apiBaseUrl,{headers: headers})
            .then(res => {
            
              
   
                  if(res.data.result != undefined)
              {
         
      
               
            for(i=0;i<res.data.result.templates.length;i++)
            {
              if(res.data.result.templates[i].id ===id){

                this.setState({template_name:res.data.result.templates[i].template_name}) 
                this.setState({template_value:res.data.result.templates[i].template_value}) 
              }
            }
             
                
           
             }
            })
    }
  


handleChange = event =>
{
      this.setState({ template_name: event.target.value});
}




handleSubmit = event =>
{
  event.preventDefault();
  var data={ 
    "template_name": this.state.template_name,
    "template_value": this.state.template_value,
    "_id":reactLocalStorage.get('id_user_edit_template')
};
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
    apiBaseUrl = API_BASE_URL + "/core/corpsms/template";
  }
  else
  {
  apiBaseUrl = API_BASE_URL+"/core/corpsms/template";
  }
  var headers = {
  'Content-Type': 'application/json',
  'token':token
    }
  axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
  {

  if(response.status === 200)
  {
    if(response.data.status === "success"){

   window.location="template";
    }
   


  }
  else if(response.status === 204){
  console.log("Something wrong");



  }
  else{
  console.log("Something wrong");


  }
  })
  .catch(function (error) {
  console.log(error);
  });

    }

    back=()=>
    {
      window.location="template";
    }
    onTextChange=(event)=>{
        this.setState({ template_value: event.target.value});
    }


  render() {
  return (
    <div className="big_div">
    <Menutest/>
    <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card request_div">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit}>
                <p className="h4 text-center py-4 text_style yellow_color">{i18n.t('Template.label')}</p>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light title_req"
                >
                
                 {i18n.t('template_name.label')}

                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="requwat"
                  required="required"
                  onChange={this.handleChange}
                  defaultValue={this.state.template_name}
                />
                <br />
               
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light title_req1"
                >
                
                 {i18n.t('text.label')}

                </label>
                <br />
                <TextArea  rows="5" onChange={this.onTextChange}
                        value={this.state.template_value}
                        style={{    width: '100%'}}
                        defaultValue={this.state.template_value}></TextArea>
                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_purple">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_purple">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div></div></div>
  );
}
};
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (EditTemplate);


